/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header__InstructionsInputs */

const en_header__instructions = /** @type {(inputs: Header__InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All translations prefixed with 'header_' should be as short as possible to fit the layout. Try to keep them at a single word while still being useful as links to the pages.`)
};

/**
* | output |
* | --- |
* | "All translations prefixed with 'header_' should be as short as possible to fit the layout. Try to keep them at a single word while still being useful as link..." |
*
* @param {Header__InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header__instructions = /** @type {((inputs?: Header__InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header__InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header__instructions(inputs)
});